<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 22 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="w-4 h-4"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.79 4.52C20.58 5.31 20.58 6.6 19.79 7.39C19 8.18 17.72 8.18 16.93 7.39C16.14 6.6 16.14 5.31 16.93 4.52C17.72 3.73 19 3.73 19.79 4.52Z"
      :fill="active ? 'url(#team_blue)' : 'url(#team_gray)'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.2 0.91C14.42 2.13 14.42 4.1 13.2 5.32C11.99 6.53 10.01 6.53 8.8 5.32C7.58 4.1 7.58 2.13 8.8 0.91C10.01 -0.3 11.99 -0.3 13.2 0.91Z"
      :fill="active ? 'url(#team_blue)' : 'url(#team_gray)'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.07 4.52C5.86 5.31 5.86 6.6 5.07 7.39C4.28 8.18 3 8.18 2.21 7.39C1.42 6.6 1.42 5.31 2.21 4.52C3 3.73 4.28 3.73 5.07 4.52Z"
      :fill="active ? 'url(#team_blue)' : 'url(#team_gray)'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.25 14H0V12.91C0 11.53 1.12 10.41 2.5 10.41H4.25"
      :fill="active ? 'url(#team_blue)' : 'url(#team_gray)'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.75 14H22V12.91C22 11.53 20.88 10.41 19.5 10.41H17.75"
      :fill="active ? 'url(#team_blue)' : 'url(#team_gray)'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.34 14V12.4C16.34 10.47 14.77 8.9 12.84 8.9H9.16C7.23 8.9 5.66 10.47 5.66 12.4V14"
      :fill="active ? 'url(#team_blue)' : 'url(#team_gray)'"
    />
    <defs>
      <linearGradient id="team_blue" x1="1" y1="12.25" x2="16.13" y2="-1.99" gradientUnits="userSpaceOnUse">
        <stop stop-color="#C7CBFF" />
        <stop offset="1" stop-color="#0012FA" />
      </linearGradient>
      <linearGradient id="team_gray" x1="1" y1="12.25" x2="16.13" y2="-1.99" gradientUnits="userSpaceOnUse">
        <stop stop-color="#D3D5E4" />
        <stop offset="1" stop-color="#585B79" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup lang="ts">
defineProps<{
  active?: boolean
}>()
</script>
